export default __webpack_public_path__ + "static/media/ministry.230acbb8.jpg";